// extracted by mini-css-extract-plugin
export var active = "_2x-j";
export var cell = "_2x-3";
export var cellLoading = "_2x-6";
export var center = "_2x-10";
export var clickable = "_2x-c";
export var compact = "_2x-4";
export var container = "_2x-8";
export var data = "_2x-a";
export var dataRow = "_2x-b";
export var dateRangeContainer = "_2x-2";
export var downloadIcon = "_2x-v";
export var empty = "_2x-e";
export var filter = "_2x-g";
export var filterContainer = "_2x-16";
export var filterCount = "_2x-i";
export var filterLabel = "_2x-h";
export var filters = "_2x-f";
export var header = "_2x-l";
export var headerButton = "_2x-m";
export var headerContent = "_2x-n";
export var headerLabel = "_2x-p";
export var headerRow = "_2x-u";
export var headerSort = "_2x-o";
export var headerSortAsc = "_2x-r";
export var headerSortContainer = "_2x-q";
export var headerSortDesc = "_2x-s";
export var headerSpacer = "_2x-t";
export var headers = "_2x-w";
export var infoIcon = "_2x-1b";
export var left = "_2x-z";
export var loader = "_2x-y";
export var loaderContainer = "_2x-x";
export var main = "_2x-9";
export var movingGradient = "_2x-7";
export var options = "_2x-0";
export var pageChangeButton = "_2x-1a";
export var pageControl = "_2x-17";
export var pageControlSticky = "_2x-18";
export var pageNumbers = "_2x-19";
export var right = "_2x-11";
export var seamless = "_2x-1";
export var spacer = "_2x-12";
export var table = "_2x-14";
export var tableContainer = "_2x-13";
export var tableFitToParent = "_2x-15";
export var textHeader = "_2x-k";
export var title = "_2x-d";
export var wide = "_2x-5";